
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { findClientById, savingClient } from "../../api";
import { useGlobalContext } from "../../context";
import { Value } from "react-date-picker/dist/cjs/shared/types";
import Header from "../../Components/Header/Header";
import americanExpress from "../../Assets/americanExpressLogo.png";
import visa from "../../Assets/visaLogo.png";
import masterCard from "../../Assets/masterCard.png";
import discover from "../../Assets/discoverLogo.png";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import DatePicker from "react-date-picker";

function EditClientInfo() {

    const {
        cNumberFormat
    } = useGlobalContext()

    const location = useLocation();
    const navigate = useNavigate();
    const [client, setClient] = useState<any>();
    const [cardholderNameValue, setCardholderNameValue] = useState<string>("");
    const [creditCardNumbersValue, setCreditCardNumbersValue] = useState<string | undefined>("");
    const [cardDigitNumValue, setCardDigitNumValue] = useState<string>("");
    const [cardExpDateValue, setCardExpDateValue] = useState<string>("");
    const [monthlyRecurringValue, setMonthlyRecurringValue] = useState<string>("");
    const [billingAddressValue, setBillingAddressValue] = useState<string>("");
    const [signUpDateValue, setSignUpDateValue] = useState<Value>();
    const [billingDateValue, setBillingDateValue] = useState<string>("");
    const [billingNotesValue, setBillingNotesValue] = useState<string>("");
    const [cardLogo, setCardLogo] = useState<string>('');
    const [cNumberAlert, setCNumberAlert] = useState<boolean>(false);

    const findClient = async (): Promise<void> => {
        try {
            const clientData = await findClientById(location.state.id);
            setClient(clientData.data);
        }
        catch (error) {
            console.log(error);
        }
    }

    const logout = () : void => {
        localStorage.removeItem("tkn");
        localStorage.removeItem("reftkn");
        localStorage.removeItem("roles");
        window.location.reload();
    }

    useEffect(() => {
        findClient();
        const timeout = setTimeout(() => {
            logout();
        }, 20 * 60 * 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [])

    useEffect(() => {
        if (client && client.creditCard !== null) {
            setCardholderNameValue(client.creditCard.cardholderName);
            setBillingAddressValue(client.creditCard.billingAddress);
            setSignUpDateValue(client.creditCard.signUpDate);
            setBillingDateValue(client.creditCard.billingDate);
            setCardExpDateValue(client.creditCard.expirationDate?.slice(0, 7));
            setMonthlyRecurringValue("$" + client.creditCard.monthlyRecurring);
            setBillingNotesValue(client.creditCard.billingNotes);
            setCardDigitNumValue(client.creditCard.cvv);
            cNumbersImg(client.creditCard.creditCardNumbers)
        }
    }, [client]);

    const cNumbersImg = (value: string) => {
        if (value) {
            setCreditCardNumbersValue(cNumberFormat(value));
            if (value.startsWith('3')) {
                setCardLogo(americanExpress);
                setCNumberAlert(false);
            }
            else if (value.startsWith('4')) {
                setCardLogo(visa);
                setCNumberAlert(false);
            }
            else if (value.startsWith('5')) {
                setCardLogo(masterCard);
                setCNumberAlert(false);
            }
            else if (value.startsWith('6')) {
                setCardLogo(discover);
                setCNumberAlert(false);
            }
            else if (value === '') {
                setCNumberAlert(false);
            }
            else {
                setCardLogo('');
                setCNumberAlert(true);
            }
        }
        else {
            setCreditCardNumbersValue("");
            setCardLogo("");
        }
    }

    const checkingDigitValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setCardDigitNumValue(value);
        if (creditCardNumbersValue?.startsWith('3')) {
            if (value.length > 4) {
                setCardDigitNumValue(value.slice(0, 4));
            }
        }
        else {
            if (value.length > 3)
                setCardDigitNumValue(value.slice(0, 3));
        }
    }

    const changeExpireDate = (value: string) => {
        setCardExpDateValue("");
        if (value.length >= 2) {
            const firstTwoValue = value.substring(0, 2);
            const beforeTwoValue = value.substring(3);
            setCardExpDateValue(`${firstTwoValue}/${beforeTwoValue}`);
        }
        else {
            setCardExpDateValue(value);
        }
    }

    const changeMonthlyRecurring = (value: string) => {
        const newValue: string = value.replace(/\$/g, '');
        setMonthlyRecurringValue("$" + newValue);
    }

    const submitCardData = async (): Promise<void> => {
        if (client) {
            if (client.creditCard && client.creditCard.id) {
                const requestData: any = {
                    id: client.id,
                    packageName: client.packageName,
                    accountManagerName: client.accountManagerName,
                    firstName: client.firstName,
                    lastName: client.lastName,
                    address: client.address,
                    phoneNumbers: client.phoneNumbers.map((item: any) => item.key + "," + item.value).join(","),
                    emails: client.emails.join(","),
                    websites: client.websites.join(","),
                    clientNameMain: client.clientNameMain,
                    includeAddressOnBranding: client.includeAddressOnBranding,
                    businessData: {
                        id: client.businessData.id,
                        companyName: client.businessData.companyName,
                        brokerageName: client.businessData.brokerageName,
                        businessType: client.businessData.businessType,
                        termForBusiness: client.businessData.termForBusiness,
                        noun: client.businessData.noun,
                        licenseNumbers: client.businessData.licenseNumbers.join(","),
                    },
                    additionalData: {
                        id: client.additionalData.id,
                        socialMediaList: client.additionalData.socialMediaList?.map((item: any) => item.key + "," + item.value).join(","),
                        facebookProfileId: client.additionalData.facebookProfileId,
                        instagramProfileId: client.additionalData.instagramProfileId,
                        accessToken: client.additionalData.accessToken,
                        hashtags: client.additionalData.hashtags,
                        customerInstruction: client.additionalData.customerInstruction,
                        additionalNotes: client.additionalData.additionalNotes,
                        leadBy: client.additionalData.leadBy,
                        soldBy: client.additionalData.soldBy,
                    },
                    creditCard: {
                        id: client.creditCard.id,
                        cardholderName: cardholderNameValue,
                        creditCardNumbers: creditCardNumbersValue,
                        cvv: cardDigitNumValue,
                        expirationDate: cardExpDateValue ? cardExpDateValue : null,
                        billingDate: parseInt(billingDateValue),
                        signUpDate: signUpDateValue && new Date(signUpDateValue.toLocaleString('en-US', {timeZone: 'Pacific/Majuro'})),
                        monthlyRecurring: monthlyRecurringValue.slice(1),
                        billingNotes: billingNotesValue,
                        billingAddress: billingAddressValue
                    }
                }

                const getData = await savingClient(JSON.stringify(requestData));
                if (getData) {
                    navigate("/billing-clients");
                }
            }
            else {
                const requestData: any = {
                    id: client.id,
                    packageName: client.packageName,
                    accountManagerName: client.accountManagerName,
                    firstName: client.firstName,
                    lastName: client.lastName,
                    address: client.address,
                    phoneNumbers: client.phoneNumbers.map((item: any) => item.key + "," + item.value).join(","),
                    emails: client.emails.join(","),
                    websites: client.websites.join(","),
                    clientNameMain: client.clientNameMain,
                    includeAddressOnBranding: client.includeAddressOnBranding,
                    businessData: {
                        id: client.businessData.id,
                        companyName: client.businessData.companyName,
                        brokerageName: client.businessData.brokerageName,
                        businessType: client.businessData.businessType,
                        termForBusiness: client.businessData.termForBusiness,
                        noun: client.businessData.noun,
                        licenseNumbers: client.businessData.licenseNumbers.join(","),
                    },
                    additionalData: {
                        id: client.additionalData.id,
                        socialMediaList: client.additionalData.socialMediaList?.map((item: any) => item.key + "," + item.value).join(","),
                        facebookProfileId: client.additionalData.facebookProfileId,
                        instagramProfileId: client.additionalData.instagramProfileId,
                        accessToken: client.additionalData.accessToken,
                        hashtags: client.additionalData.hashtags,
                        customerInstruction: client.additionalData.customerInstruction,
                        additionalNotes: client.additionalData.additionalNotes,
                        leadBy: client.additionalData.leadBy,
                        soldBy: client.additionalData.soldBy,
                    },
                    creditCard: {
                        cardholderName: cardholderNameValue,
                        creditCardNumbers: creditCardNumbersValue,
                        cvv: cardDigitNumValue,
                        expirationDate: cardExpDateValue ? cardExpDateValue : null,
                        billingDate: parseInt(billingDateValue),
                        signUpDate: signUpDateValue && new Date(signUpDateValue.toLocaleString('en-US', { timeZone: 'Pacific/Majuro' })),
                        monthlyRecurring: monthlyRecurringValue.slice(1),
                        billingNotes: billingNotesValue,
                        billingAddress: billingAddressValue
                    }
                }
                const getData = await savingClient(JSON.stringify(requestData));
                if (getData) {
                    navigate("/billing-clients");
                }
            }
        }
    }

    return(
        <div className = "edit-client">
            <Header/>
            <div className = "CreditCard billing-edit-credit-card" >
                <div className = "createClient-form-cc">
                    <div className = "createClient-header">
                        <span className = "createClientLeftArrowBox">
                            <KeyboardArrowLeftIcon
                                style = {{
                                    color: "#004DE7"
                                }}
                                onClick = { () => window.history.back() }
                            />
                        </span>
                        <h2>Edit Credit Card</h2>
                    </div>
                    <div className = "createClient-form-type">
                        <div className = "form-type-box">
                            <label>Name</label>
                        </div>
                        <div className = "form-type-box mrg-btm">
                            <input
                                id = "holderNameInp"
                                className = "type-box-type-input"
                                type = "text"
                                value = { cardholderNameValue }
                                onChange = { e => setCardholderNameValue(e.target.value) }
                            />
                        </div>
                    </div>
                    <div className = "createClient-form-type">
                        <div className = "form-type-box">
                            <label>Numbers</label>
                        </div>
                        <div className = "form-type-box mrg-btm">
                            <input
                                type = "text"
                                className = "type-box-type-input"
                                value = { creditCardNumbersValue }
                                onChange = { event => cNumbersImg(event.target.value) }
                            />
                            {
                                cardLogo && <img src = { cardLogo } alt = "Credit Card Logo"/>
                            }
                        </div>
                        <div className="ccNumbers-Wrong mrg-btm">
                            <span
                                style = {{
                                    display: cNumberAlert ? "block" : "none"
                                }}
                            >
                                Wrong Card Numbers
                            </span>
                        </div>
                    </div>
                    <div className = "createClient-form-cc-block">
                        <div className = "cc-block-box">
                            <div className = "form-type-box">
                                <label>CVV</label>
                            </div>
                            <div className = "form-type-box mrg-btm">
                                <input
                                    className = "type-box-type-input credit-card-small-input"
                                    type = "number"
                                    value = { cardDigitNumValue }
                                    onChange = { checkingDigitValue }
                                />
                            </div>
                        </div>
                        <div className = "cc-block-box">
                            <div className = "form-type-box">
                                <label>Expiration Date</label>
                            </div>
                            <div className = "form-type-box mrg-btm">
                                <input
                                    placeholder = "mm/yy"
                                    className = "type-box-type-input credit-card-small-input"
                                    type = "text"
                                    maxLength = { 5 }
                                    value = { cardExpDateValue }
                                    onChange = { e => changeExpireDate(e.target.value) }
                                />
                            </div>
                        </div>
                        <div className = "cc-block-box">
                            <div className = "form-type-box">
                                <label>Monthly Recurring</label>
                            </div>
                            <div className = "form-type-box mrg-btm">
                                <input
                                    className = "type-box-type-input credit-card-small-input"
                                    placeholder = "$"
                                    type = "string"
                                    value = { monthlyRecurringValue }
                                    onChange = { e => changeMonthlyRecurring(e.target.value) }
                                />
                            </div>
                        </div>
                    </div>
                    <div className = "createClient-form-type">
                        <div className = "form-type-box">
                            <label>Billing Address / Zip Code</label>
                        </div>
                        <div className = "form-type-box mrg-btm">
                            <input
                                className = "type-box-type-input"
                                type = "text"
                                value = { billingAddressValue }
                                onChange = { e => setBillingAddressValue(e.target.value) }
                            />
                        </div>
                    </div>
                    <div className = "createClient-form-cc-block">
                        <div className = "cc-block-box mrg-btm">
                            <div className = "form-type-box">
                                <label>Sign Up Date</label>
                            </div>
                            <div className = "form-type-box">
                                <DatePicker
                                    onChange={e => {
                                        if (e) {
                                            setSignUpDateValue(e)
                                        }
                                    }}
                                    value = {signUpDateValue}
                                    dayPlaceholder = {"dd"}
                                    monthPlaceholder = {"mm"}
                                    yearPlaceholder = {"yyyy"}
                                    format = {"MM-dd-y"}
                                    clearIcon = { false }
                                />
                            </div>
                        </div>
                        <div className = "cc-block-box mrg-btm">
                            <div className = "form-type-box">
                                <label>Billing Date</label>
                            </div>
                            <div className = "form-type-box">
                                <input
                                    placeholder = ""
                                    className = "type-box-type-input"
                                    type = "number"
                                    value = { billingDateValue }
                                    onChange = { e => setBillingDateValue(e.target.value) }
                                />
                            </div>
                        </div>
                    </div>
                    <div className = "createClient-form-type">
                        <div className = "form-type-box">
                            <label>Billing Notes</label>
                        </div>
                        <div className = "form-type-box mrg-btm">
                            <textarea
                                rows = { 4 }
                                className = "type-box-type-input"
                                value = { billingNotesValue }
                                onChange = { e => setBillingNotesValue(e.target.value) }
                            />
                        </div>
                    </div>
                    <div className = "createClient-submit-btn">
                        <button
                            style = {{
                                cursor: "pointer",
                                backgroundColor: "#004DE7",
                                color: "white",
                            }}
                            onClick = { submitCardData }
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditClientInfo